import React from "react";
import { Link } from "react-router-dom";

const toneClasses = {
  red: {
    card: "border-red-100 bg-red-50/80",
    dot: "bg-red-500",
    text: "text-red-700",
  },
  amber: {
    card: "border-amber-100 bg-amber-50/80",
    dot: "bg-amber-500",
    text: "text-amber-700",
  },
  blue: {
    card: "border-blue-100 bg-blue-50/80",
    dot: "bg-blue-500",
    text: "text-blue-700",
  },
  green: {
    card: "border-emerald-100 bg-emerald-50/80",
    dot: "bg-emerald-500",
    text: "text-emerald-700",
  },
};

const TodaysAttention = ({ items = [], isLoading }) => {
  const visibleItems = items.slice(0, 6);

  return (
    <section className="rounded-3xl border border-slate-200/80 bg-white/95 p-5 shadow-sm md:p-6">
      <div className="mb-5 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-400">
            Action Center
          </p>
          <h2 className="mt-1 text-2xl font-semibold tracking-tight text-slate-950">
            Today&apos;s Attention
          </h2>
          <p className="mt-1 text-sm text-slate-500">
            Priority items and missing care signals for the current day.
          </p>
        </div>
        <Link
          to="/daily-care-log"
          className="inline-flex min-h-10 items-center justify-center rounded-full bg-slate-950 px-4 text-sm font-semibold text-white transition hover:bg-slate-800"
        >
          Add Care Record
        </Link>
      </div>

      {isLoading ? (
        <div className="rounded-2xl bg-slate-50 p-4 text-sm text-slate-500">
          Checking today&apos;s activity...
        </div>
      ) : visibleItems.length === 0 ? (
        <div className="rounded-2xl border border-emerald-100 bg-emerald-50/80 p-4">
          <p className="font-semibold text-emerald-900">
            Nothing urgent right now.
          </p>
          <p className="mt-1 text-sm text-emerald-700">
            Today&apos;s core care signals are up to date.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
          {visibleItems.map((item) => {
            const tone = toneClasses[item.tone] || toneClasses.blue;
            return (
              <div
                key={item.id}
                className={`rounded-2xl border p-4 transition hover:shadow-sm ${tone.card}`}
              >
                <div className="flex items-start gap-3">
                  <span
                    className={`mt-1 h-2.5 w-2.5 rounded-full ${tone.dot}`}
                  />
                  <div className="min-w-0 flex-1">
                    <p className="font-semibold text-slate-950">{item.title}</p>
                    <p className="mt-1 text-sm leading-5 text-slate-600">
                      {item.detail}
                    </p>
                    {item.to && item.actionLabel && (
                      <Link
                        to={item.to}
                        className={`mt-3 inline-flex text-sm font-semibold ${tone.text}`}
                      >
                        {item.actionLabel}
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default TodaysAttention;
